var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDesapproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5615 7.43968C14.9759 6.85369 14.0262 6.85341 13.4402 7.43902C13.44 7.43925 13.4397 7.43949 13.4395 7.43968L11.5005 9.37969L9.56152 7.43968C8.97553 6.85369 8.02547 6.85369 7.43953 7.43968C6.8536 8.02566 6.85355 8.97572 7.43953 9.56166L9.3795 11.5007L7.43949 13.4397C6.8535 14.0257 6.8535 14.9757 7.43949 15.5617C8.02547 16.1476 8.97554 16.1476 9.56147 15.5617L11.5005 13.6217L13.4395 15.5617C14.0255 16.1477 14.9755 16.1477 15.5615 15.5617C16.1475 14.9757 16.1475 14.0257 15.5615 13.4397L13.6215 11.5007L15.5615 9.56171C16.1475 8.9761 16.1478 8.02636 15.5622 7.44038C15.5619 7.44014 15.5618 7.43991 15.5615 7.43968Z",
    fill: "#94A8BE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24H5.49998C2.4638 23.9967 0.00332812 21.5362 0 18.5V5.49998C0.00332812 2.4638 2.4638 0.00332812 5.49998 0H18.5C21.5362 0.00332812 23.9967 2.4638 24 5.49998V18.5C23.9967 21.5362 21.5362 23.9967 18.5 24ZM5.49998 3C4.11928 3 3 4.11928 3 5.49998V18.5C3 19.8807 4.11928 21 5.49998 21H18.5C19.8807 21 21 19.8807 21 18.5V5.49998C21 4.11928 19.8807 3 18.5 3H5.49998Z",
    fill: "#94A8BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDesapproved);
export default __webpack_public_path__ + "static/media/status-desapproved.92ee37161a31a97c6824a48cd83253bb.svg";
export { ForwardRef as ReactComponent };